export const AppRoutes = {
  // Login
  login: "/login",
  logout: "/logout",
  recover: "/recover",
  resetPassword: "/reset-password",
  register: "/register",
  adminAuthCallback: "/auth/callback",

  // Home
  home: "/",

  // Rso
  rsoList: "/rso",
  rsoCreate: "/rso/create",
  rsoDetail: "/rso/:id/detail",
  rsoEdit: "/rso/:id/edit",
  rsoUserCreate: "/rso/:id/user/create",
  rsoUserEdit: "/rso/:id/user/:userId/edit",

  // information
  information: "/information",
  informationCreate: "/information/create",
  informationEdit: "/information/:id/edit",

  // Convert
  convert: "/convert",
  convertHistory: "/convert/history",
  convertDetail: "/convert/:id",

  // Master data
  masterData: "/master-data",
  masterDataDetail: "/master-data/:type",

  // Contact
  contactList: "/contact",
  contactDetail: "/contact/:id",
  // Contact type
  contactTypeCreate: "/contact-type/create",
  contactTypeEdit: "/contact-type/:id/edit",

  // Company Contact
  companyContactList: "/company/contact",
  companyContactDetail: "/company/contact/:id",
  // Company Contact type
  companyContactTypeCreate: "/company/contact-type/create",
  companyContactTypeEdit: "/company/contact-type/:id/edit",

  // System setting
  setting: "/setting",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Chat
  chat: "/chat",
  chatDetail: "/chat/:id",

  // Chat
  companyChat: "/company/chat",
  companyChatDetail: "/company/chat/:id",

  // Company
  companyList: "/company",
  companyCreate: "/company/create",
  companyDetail: "/company/:id/detail",
  companyEdit: "/company/:id/edit",
  companyUserCreate: "/company/:id/user/create",
  companyUserEdit: "/company/:id/user/:userId/edit",

  // Organization
  organizationTypeSelect: "/organization-type-select",
};

export const DashboardRoutes = [AppRoutes.home];

export const RsoRoutes = [
  AppRoutes.rsoList,
  AppRoutes.rsoCreate,
  AppRoutes.rsoDetail,
  AppRoutes.rsoEdit,
  AppRoutes.rsoUserCreate,
  AppRoutes.rsoUserEdit,
];

export const CompanyRoutes = [
  AppRoutes.companyList,
  AppRoutes.companyCreate,
  AppRoutes.companyDetail,
  AppRoutes.companyEdit,
  AppRoutes.companyUserCreate,
  AppRoutes.companyUserEdit,
];

export const InformationRoutes = [AppRoutes.information, AppRoutes.informationCreate, AppRoutes.informationEdit];

export const ConvertRoutes = [AppRoutes.convert, AppRoutes.convertHistory, AppRoutes.convertDetail];

export const MasterDataRoutes = [AppRoutes.masterData, AppRoutes.masterDataDetail];

export const ContactRoutes = [AppRoutes.contactList, AppRoutes.contactDetail, AppRoutes.contactTypeCreate, AppRoutes.contactTypeEdit];

export const CompanyContactRoutes = [
  AppRoutes.companyContactList,
  AppRoutes.companyContactDetail,
  AppRoutes.companyContactTypeCreate,
  AppRoutes.companyContactTypeEdit,
];

export const SystemSettingRoutes = [AppRoutes.setting];

export const ChatRoutes = [AppRoutes.chat, AppRoutes.chatDetail];
export const CompanyChatRoutes = [AppRoutes.companyChat, AppRoutes.companyChatDetail];
export const HomeRoutes = [AppRoutes.home];

export const OrganizationRoutes = [AppRoutes.organizationTypeSelect];

export const AdminRoutes = [
  HomeRoutes,
  RsoRoutes,
  InformationRoutes,
  ContactRoutes,
  SystemSettingRoutes,
  ChatRoutes,
  ConvertRoutes,
  MasterDataRoutes,
  CompanyChatRoutes,
  CompanyContactRoutes,
  CompanyRoutes,
  OrganizationRoutes,
].flat();
